import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth() {
  const { accessToken, bootstrapping } = useAuth();

  if (bootstrapping) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (!accessToken) return <Navigate to="/" replace />;

  return <Outlet />;
}
